import createCache from "@emotion/cache";

/**
 * Reads the CSP nonce the Go BFF templates into index.html
 * (`<meta name="csp-nonce" content="...">`). Emotion attaches it to every
 * <style> tag it inserts, so the portal's CSP can allow style-src with
 * only that nonce and no 'unsafe-inline' (see README.md "Content Security
 * Policy").
 */
function readCspNonce(): string | undefined {
  const meta = document.querySelector('meta[name="csp-nonce"]');
  const content = meta?.getAttribute("content");
  return content ? content : undefined;
}

export const emotionCache = createCache({
  key: "leeft",
  nonce: readCspNonce(),
});
